import { render, staticRenderFns } from "./internal-movement-details.component.vue?vue&type=template&id=5571f83e&scoped=true&"
import script from "./internal-movement-details.component.vue?vue&type=script&lang=ts&"
export * from "./internal-movement-details.component.vue?vue&type=script&lang=ts&"
import style0 from "./internal-movement-details.component.vue?vue&type=style&index=0&id=5571f83e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5571f83e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSwitch,VTextField,VTextarea})
